import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const CallRecordingIcon = createSvgIcon({
  svg: ({ classes }) => (
    <svg role="presentation" focusable="false" viewBox="8 8 16 16" className={classes.svg}>
      <circle cx="16" cy="16" r="4.6" />
      <path d="M16 8c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 14.3c-3.5 0-6.3-2.8-6.3-6.3s2.8-6.3 6.3-6.3 6.3 2.8 6.3 6.3-2.8 6.3-6.3 6.3z" />
    </svg>
  ),
  displayName: 'CallRecordingIcon',
});

export default CallRecordingIcon;
